export default "__VITE_ASSET__B8iV8QDS__"